import { Spacer, VDBText } from "@components/atoms";
import { SpaceType } from "@components/atoms/Spacer/types";
import VDBIcon, { IconsVariant } from "@components/icons/VDBIcon";
import { VDBIcons } from "@utils/VDBIcons";
import styled from "styled-components/native";
import { OptionHeaderProps } from "./types";
import React, { useState } from "react";
import RenderHTML from "react-native-render-html";
import { getProductBorderColor } from "@components/molecules/MatchStoneGalleryModel/Utils";
import { Linking, View } from "react-native";
import PreviewLinkModal from "@scenes/configurator/PreviewLinkModal";
import useScreenOptionsHooks from "../../../../hooks/useScreenOptionsHooks";

const OptionHeader = ({
  title,
  value,
  productType,
  showCarousel = false,
  helperText = "",
  onLeftSliderPress,
  onRightSliderPress,
  leftSliderDisabled,
  rightSliderDisabled,
  fromReviewPage,
  isOpen,
  onToggle,
  fromOrderCart,
  fromRequest,
  disableToggleButton = false,
}: OptionHeaderProps) => {
  const { t, theme, typography } = useScreenOptionsHooks();
  const defaultColor = getProductBorderColor(productType);
  const [showPreviewOverlay, setShowPreviewOverlay] = useState("");

  const renderersProps = {
    a: {
      onPress(...args: any[]) {
        const href = args[1];
        if (href) {
          const url = new URL(href);
          if (
            url.pathname.includes("openOverlay") ||
            url.searchParams.has("openOverlay")
          ) {
            setShowPreviewOverlay(href);
          } else {
            Linking.canOpenURL(href).then((supported) => {
              supported && Linking.openURL(href);
            });
          }
        }
      },
    },
  };

  const renderPreviewLink = () => {
    return (
      <RenderHTML
        source={{
          html: `${helperText}`,
        }}
        defaultTextProps={{
          selectable: true,
        }}
        tagsStyles={{
          span: {
            ...typography["H3-R"],
            color: theme["core-06"],
          },
          a: { ...typography["H3-M"], color: theme[defaultColor] },
        }}
        renderersProps={renderersProps}
      />
    );
  };

  return (
    <>
      <HeaderView>
        <TitleView
          enablePaddingBottom={
            helperText && !showCarousel && (fromReviewPage ? isOpen : false)
          }
        >
          <VDBText color={theme["core-05"]} type={typography["H3-M"]}>
            {title}
          </VDBText>
          {value && (
            <VDBText color={theme["core-05"]} type={typography["H3-R"]}>
              {": "}
              {value}
            </VDBText>
          )}
        </TitleView>
        {fromReviewPage &&
          !isOpen &&
          !fromOrderCart &&
          !fromRequest &&
          !disableToggleButton && (
            <ToggleButton onPress={onToggle}>
              <VDBText color={theme["jewelry-06"]} type={typography["Body-M"]}>
                {t("reviewPage.modify.button.text")}
              </VDBText>
            </ToggleButton>
          )}
        {helperText && !showCarousel && (fromReviewPage ? isOpen : true) && (
          <View style={{ flexShrink: 1 }}>{renderPreviewLink()}</View>
        )}
        {showCarousel && (fromReviewPage ? isOpen : true) && (
          <RightView>
            <LeftSliderButton onPress={onLeftSliderPress}>
              <VDBIcon
                color={leftSliderDisabled ? theme["core-04"] : theme["core-06"]}
                size={24}
                variant={IconsVariant.VDBCustom}
                name={VDBIcons.ARROW_LEFT}
              />
            </LeftSliderButton>
            <RightSliderButton onPress={onRightSliderPress}>
              <VDBIcon
                color={
                  rightSliderDisabled ? theme["core-04"] : theme["core-06"]
                }
                size={24}
                variant={IconsVariant.VDBCustom}
                name={VDBIcons.ARROW_RIGHT}
              />
            </RightSliderButton>
          </RightView>
        )}
      </HeaderView>
      {helperText && showCarousel && (
        <>
          <Spacer size={SpaceType.ExtraSmall} />
          {renderPreviewLink()}
        </>
      )}
      <PreviewLinkModal
        preview_link={showPreviewOverlay}
        isOpen={showPreviewOverlay !== ""}
        onClose={() => {
          setShowPreviewOverlay("");
        }}
      />
    </>
  );
};

const HeaderView = styled.View`
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
`;

const TitleView = styled.View<{
  enablePaddingBottom?: boolean;
}>`
  flex-direction: row;
  height: 24px;
  align-items: center;
  padding-bottom: ${({
    enablePaddingBottom,
  }: {
    enablePaddingBottom: boolean;
  }) => (enablePaddingBottom ? 4 : 0)}px;
`;

const RightView = styled.View`
  flex-direction: row;
  gap: ${SpaceType.Basic}px;
`;

const LeftSliderButton = styled.Pressable``;
const RightSliderButton = styled.Pressable``;

const ToggleButton = styled.Pressable`
  margin-left: 8px;
`;

export default OptionHeader;
